export * as attachments from '@wix/auto_sdk_crm_attachments/meta';
export * as contacts from '@wix/auto_sdk_crm_contacts/meta';
export * as extendedFields from '@wix/auto_sdk_crm_extended-fields/meta';
export * as labels from '@wix/auto_sdk_crm_labels/meta';
export * as submittedContact from '@wix/auto_sdk_crm_submitted-contact/meta';
export * as notes from '@wix/auto_sdk_crm_notes/meta';
export * as cards from '@wix/auto_sdk_crm_cards/meta';
export * as pipelines from '@wix/auto_sdk_crm_pipelines/meta';
export * as tasks from '@wix/auto_sdk_crm_tasks/meta';
